import React, { useState, useEffect } from 'react';
import Layout from '../../components/layout/Layout';
import FiltroRelatorios from '../../components/relatorios/FiltroRelatorios';
import RelatorioResumo from '../../components/relatorios/RelatorioResumo';
import RelatorioAtendimentos from '../../components/relatorios/RelatorioAtendimentos';
import RelatorioReceitas from '../../components/relatorios/RelatorioReceitas';
import RelatorioProdutividade from '../../components/relatorios/RelatorioProdutividade'; // Importar o componente de produtividade
import {
  fetchAtendimentos,
  fetchClinicas,
  fetchPacientes,
} from '../../services/firebaseService';
import DownloadPDFButton from '../../components/relatorios/DownloadPDFButton';

function RelatoriosPage() {
  const [clinicas, setClinicas] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [atendimentos, setAtendimentos] = useState([]);
  const [filteredAtendimentos, setFilteredAtendimentos] = useState([]);

  const [clinica, setClinica] = useState('');
  const [paciente, setPaciente] = useState('');
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [agruparPor, setAgruparPor] = useState('clinica'); // Novo estado para agrupar por paciente ou clínica

  useEffect(() => {
    async function loadData() {
      const fetchedClinicas = await fetchClinicas();
      const fetchedPacientes = await fetchPacientes();
      const fetchedAtendimentos = await fetchAtendimentos();

      setClinicas(fetchedClinicas);
      setPacientes(fetchedPacientes);
      setAtendimentos(fetchedAtendimentos);
    }

    loadData();
  }, []);

  useEffect(() => {
    const filtrados = atendimentos.filter((atendimento) => {
      const matchesClinica = clinica ? atendimento.clinicaId === clinica : true;
      const matchesPaciente = paciente
        ? atendimento.pacienteId === paciente
        : true;
      const matchesData =
        dataInicio && dataFim
          ? new Date(atendimento.dataAtendimento) >= new Date(dataInicio) &&
            new Date(atendimento.dataAtendimento) <= new Date(dataFim)
          : true;
      return matchesClinica && matchesPaciente && matchesData;
    });
    setFilteredAtendimentos(filtrados);
  }, [clinica, paciente, dataInicio, dataFim, atendimentos]);

  return (
    <Layout>
      <section className="relatorios-page max-w-7xl mx-auto p-4">
        <h2 className="text-3xl font-semibold mb-6">
          Relatórios de Atendimentos
        </h2>
        <FiltroRelatorios
          clinicas={clinicas}
          pacientes={pacientes}
          setClinica={setClinica}
          setPaciente={setPaciente}
          setDataInicio={setDataInicio}
          setDataFim={setDataFim}
        />
        <RelatorioResumo
          totalAtendimentos={filteredAtendimentos.length}
          pacientesUnicos={
            [...new Set(filteredAtendimentos.map((a) => a.pacienteId))].length
          }
          atendimentosPorDia={
            filteredAtendimentos.length /
            Math.max(
              1,
              (new Date(dataFim) - new Date(dataInicio)) / (1000 * 60 * 60 * 24)
            )
          }
        />

        {/* Relatório de Produtividade */}
        <RelatorioProdutividade
          atendimentos={filteredAtendimentos} // Passando os atendimentos filtrados
          agruparPor={agruparPor} // Definindo se é por clínica ou paciente
        />

        <div className="my-4">
          <label className="text-lg font-medium mr-4">Agrupar por:</label>
          <select
            className="p-2 border rounded-md"
            value={agruparPor}
            onChange={(e) => setAgruparPor(e.target.value)}
          >
            <option value="clinica">Clínica</option>
            <option value="paciente">Paciente</option>
          </select>
        </div>

        <RelatorioReceitas
          atendimentos={filteredAtendimentos}
          agruparPor={agruparPor}
        />
        <RelatorioAtendimentos atendimentos={filteredAtendimentos} />
        <div className="mt-6">
          <DownloadPDFButton atendimentos={filteredAtendimentos} />
        </div>
      </section>
    </Layout>
  );
}

export default RelatoriosPage;
